<div class="td-cnt-ext">
    <div class="td-cnt"
        [ngClass]="{'td-cnt-mobile' : isMobile, 'td-cnt-big' : feasibilityStatus != 'ToBeEvaluated' && action == ''}">
        <div class="td-cnt-title">
            <i class="fas fa-tools dialog-icon"></i>
            <span class="te-title">{{title}}</span>
        </div>
        <!-- TO BE EVALUATED -->
        <div *ngIf="feasibilityStatus == 'ToBeEvaluated' && action == ''" class="td-cnt-body flex-col">
            <div class="cnt-btns">
                <teiasoft-button (onClick)="onSearchByExpClick()" [type]="'tb-primary'"
                    [text]="'feasibility.byExperience' | translate" [noWidth]="true" [fullWidth]="true"
                    [isMobile]="isMobile" style="width:100%; margin-bottom:2vh"></teiasoft-button>
            </div>
        </div>

        <!-- INPUT REMARKS -->
        <div *ngIf="feasibilityStatus == 'ToBeEvaluated' && action == 'searchByExp'" class="td-cnt-body flex-col-left"
            style="margin-top: 2vh;">
            <span class="bold" style="margin-bottom: 1vh;">{{'feasibility.remarks' | translate}}</span>
            <textarea style="width:95%" rows="8" [ngModel]="comments" (change)="onInputChange($event)"></textarea>
        </div>

        <!-- VIEW -->
        <div *ngIf="feasibilityStatus != 'ToBeEvaluated' && action == '' && feasibilityDetail" class="td-cnt-body"
            style="justify-content: flex-start;flex-direction: column;">
            <ng-container *ngIf="feasibilityDetail.feasibilityByExperienceDetails">
                <div class="mf-row" style="margin-top: 2vh;">
                    <div class="mf-cell">
                        <span class="bold" style="margin-bottom: 1vh;">{{'grid.Username' | translate}}</span>
                        <span>{{feasibilityDetail.feasibilityByExperienceDetails!.username}}</span>
                    </div>

                    <div class="mf-cell" style="align-items: flex-end;">
                        <span class="bold" style="margin-bottom: 1vh;">{{'grid.LogTimestamp' | translate}}</span>
                        <span>{{feasibilityDetail.feasibilityByExperienceDetails!.timestamp |
                            date:globals.dateTimeFormat}}</span>
                    </div>
                </div>
                <div class="sep"></div>

                <div class="mf-cell-big">
                    <!-- <span class="bold" style="margin-bottom: 1vh;">{{'feasibility.remarks' | translate}}</span> -->
                    <span class="mf-span">{{(feasibilityDetail.feasibilityByExperienceDetails!.comments! != '' ?
                        feasibilityDetail.feasibilityByExperienceDetails!.comments! : '--')}}</span>
                </div>
            </ng-container>

            <ng-container *ngIf="feasibilityDetail.feasibilityByItrDetails">
                <div class="mf-row" style="margin-top: 2vh;">
                    <span [innerHTML]="feasibilityDetail.feasibilityByItrDetails!.description || '---'"></span>
                </div>
            </ng-container>
            <div *ngIf="showItdcrHistoryLink" class="modal-link-bottom-right">
                <div class="cnt-link">
                    <i class="fas fa-caret-right ico-link"></i>
                    <teiasoft-link [text]="'enquiryBook.viewITDCR' | translate"
                        (onClick)="onNavigateToItdcrHistory()"></teiasoft-link>
                </div>
            </div>
            <!-- 
            <div class="mf-cell-33" style="align-items: center;">
                <span class="bold" style="margin-bottom: 1vh;">{{'feasibility.feasibilityByStandardBookDetails' | translate}}</span>
                <span>{{feasibilityDetail.feasibilityByStandardBookDetails! != null ? feasibilityDetail.feasibilityByStandardBookDetails! : '--'}}</span>
            </div>

            <div class="mf-cell-33" style="align-items: flex-end;">
                <span class="bold" style="margin-bottom: 1vh;">{{'feasibility.feasibilitySource' | translate}}</span>
                <span>{{feasibilityDetail.feasibilitySource}}</span>
            </div> -->
        </div>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button *ngIf="action == 'searchByExp'" (onClick)="onDeclareItemFeasbile()" class="mr-5"
                [type]="'tb-secondary'" [text]="'feasibility.declareItemFeas' | translate"
                [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onCancelClick()" class="mr-5" [type]="'tb-cancel'"
                [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
            <ng-container *ngIf="!readOnly">
                <teiasoft-button [type]="'tb-primary'" [text]="'costingTool.openITR' | translate" [isMobile]="isMobile"
                    [disabled]="false" [noWidth]="true" [fullWidth]="true"
                    (onClick)="onOpenITDCRClick()"></teiasoft-button>
            </ng-container>
        </div>
    </div>
</div>
<app-modal-view-itdcr *ngIf="showItdcrViewerModal" [itdcrNo]="selectedItdcrNo" [showHistory]="true"
    (onClose)="onCloseItdcrViewer()"></app-modal-view-itdcr>
